<template>
  <div>
    <div v-for="section in handler.dateSections(lowerQ)">
      <field-item
          :disabled="handler.isDisabled(section, parentTreeContext)"
          @click="select(section.select(section))"
      >
        <row>
          <prefix>
            <icon glyph="datepicker" />
          </prefix>
          <column>
            {{section.label}}
          </column>
        </row>
      </field-item>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import handlerComponentsMixin from '../mixins/handlerComponentsMixin';
import DynamicFieldsHandler from "~/models/dynamicFields/handlers/dynamicFieldsHandler";
import FieldItem from './common/field-item.vue';
import handlerTreeContextMixin from '~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin'

export default Vue.extend({
  mixins: [
    handlerComponentsMixin,
    handlerTreeContextMixin,
  ],
  components: {
    FieldItem,
  },
  props: {
    handler: {
      type: Object as () => DynamicFieldsHandler,
      required: true,
    },
  },
  computed: {
  },
  methods: {
  },
});
</script>